import { render } from "./ActivePage.vue?vue&type=template&id=e12a0ac8&scoped=true"
import script from "./ActivePage.vue?vue&type=script&lang=js"
export * from "./ActivePage.vue?vue&type=script&lang=js"

import "./ActivePage.vue?vue&type=style&index=0&id=e12a0ac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12a0ac8"]])

export default __exports__